import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7fe16a21"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "grid"
};
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Id*", -1));
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Display Name*", -1));
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = { class: "user-edit-brand-button-wrapper" };
import { ref } from "vue";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import { updateMarket, } from "@/repositories/market.repository";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import { mandatoryField } from "@/shared/utils/validation";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import useFormValidation from "@/shared/composables/useFormValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpdateMarket',
    props: {
        "modelValue": { required: true },
        "modelModifiers": {},
    },
    emits: /*#__PURE__*/ _mergeModels(["market-updated"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const notify = useToastNotify();
        const { validationStateDict, invalidForm } = useFormValidation();
        const modelValue = _useModel(__props, "modelValue");
        const market = ref({ ...modelValue.value });
        const emit = __emit;
        const onSave = async () => {
            try {
                if (invalidForm.value) {
                    notify("", "Please enter the mandatory fields", "warn");
                }
                else {
                    await updateMarket({
                        id: market.value.id,
                        displayMarket: market.value.displayMarket,
                    });
                    emit("market-updated");
                    notify("", `Market : ${market.value.id} has been successfully updated`, "success");
                }
            }
            catch (error) {
                notify("", error.message, "warn");
            }
        };
        return (_ctx, _cache) => {
            return (market.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(OneDeskInput, {
                            modelValue: market.value.id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((market.value.id) = $event)),
                            "data-testid": "market-id",
                            class: "wp-pages-inputs",
                            disabled: true,
                            rules: [_unref(mandatoryField)],
                            "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (_unref(validationStateDict).id = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_3
                            ]),
                            _: 1
                        }, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(OneDeskInput, {
                            modelValue: market.value.displayMarket,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((market.value.displayMarket) = $event)),
                            "data-testid": "display-markets",
                            class: "wp-pages-inputs",
                            rules: [_unref(mandatoryField)],
                            "onUpdate:valid": _cache[3] || (_cache[3] = ($event) => (_unref(validationStateDict).displayMarket = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_5
                            ]),
                            _: 1
                        }, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(OneDeskButton, {
                                label: "Save",
                                "data-testid": "save-button",
                                icon: "pi pi-save",
                                disabled: _unref(invalidForm),
                                onClick: onSave
                            }, null, 8, ["disabled"])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
